// import { State } from "../Model/State";
// import { Player } from "../Model/Player";
// import { Game } from "../Model/Game";
export class BoardsService {
    constructor(httpService, playerService, boardsFactory, realTimeService) {
        this.httpService = httpService;
        this.playerService = playerService;
        this.boardsFactory = boardsFactory;
        this.realTimeService = realTimeService;
    }
    async createBoard(roomId, gameId, gameCode) {
        if (!this.playerService.isRegistered.value) {
            throw new Error('No es posible crear un cartón mientras el jugador no está registrado.');
        }
        const response = await this.httpService.post('board', {
            roomId: roomId,
            gameId,
            gameCode,
            playerId: this.playerService.getPlayer().id,
        });
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al crear el cartón de juego.');
        }
    }
    async getBoard(roomId, gameId) {
        if (!this.playerService.isRegistered.value) {
            throw new Error('No es posible obtener un cartón mientras el jugador no está registrado.');
        }
        const response = await this.httpService.get(`board/${roomId}/${gameId}/${this.playerService.getPlayer().id}`);
        if (response.status === 404) {
            return null;
        }
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener el cartón de juego.');
        }
        return this.boardsFactory.createBoardFromDto(await response.json());
    }
    checkCell(boardId, number) {
        //console.log('check_cell', number)
        this.realTimeService.send('check_cell', { boardId, number });
    }
}
